module.exports = __webpack_public_path__ + "img/JS.08802079.svg";